import _classCallCheck from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectSpread from "/Users/elliotwaterhouse/Desktop/GitHub/partners_aps/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
var matchName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
var iconDefaults = Object.freeze({
  left: 0,
  top: 0,
  width: 16,
  height: 16,
  rotate: 0,
  vFlip: false,
  hFlip: false
});

function fullIcon(data) {
  return _objectSpread({}, iconDefaults, data);
}

var stringToIcon = function stringToIcon(value, validate, allowSimpleName) {
  var provider = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  var colonSeparated = value.split(":");

  if (value.slice(0, 1) === "@") {
    if (colonSeparated.length < 2 || colonSeparated.length > 3) {
      return null;
    }

    provider = colonSeparated.shift().slice(1);
  }

  if (colonSeparated.length > 3 || !colonSeparated.length) {
    return null;
  }

  if (colonSeparated.length > 1) {
    var name2 = colonSeparated.pop();
    var prefix = colonSeparated.pop();
    var result = {
      provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
      prefix: prefix,
      name: name2
    };
    return validate && !validateIcon(result) ? null : result;
  }

  var name = colonSeparated[0];
  var dashSeparated = name.split("-");

  if (dashSeparated.length > 1) {
    var _result = {
      provider: provider,
      prefix: dashSeparated.shift(),
      name: dashSeparated.join("-")
    };
    return validate && !validateIcon(_result) ? null : _result;
  }

  if (allowSimpleName && provider === "") {
    var _result2 = {
      provider: provider,
      prefix: "",
      name: name
    };
    return validate && !validateIcon(_result2, allowSimpleName) ? null : _result2;
  }

  return null;
};

var validateIcon = function validateIcon(icon, allowSimpleName) {
  if (!icon) {
    return false;
  }

  return !!((icon.provider === "" || icon.provider.match(matchName)) && (allowSimpleName && icon.prefix === "" || icon.prefix.match(matchName)) && icon.name.match(matchName));
};

function mergeIconData(icon, alias) {
  var result = _objectSpread({}, icon);

  for (var key in iconDefaults) {
    var prop = key;

    if (alias[prop] !== void 0) {
      var value = alias[prop];

      if (result[prop] === void 0) {
        result[prop] = value;
        continue;
      }

      switch (prop) {
        case "rotate":
          result[prop] = (result[prop] + value) % 4;
          break;

        case "hFlip":
        case "vFlip":
          result[prop] = value !== result[prop];
          break;

        default:
          result[prop] = value;
      }
    }
  }

  return result;
}

function getIconData$1(data, name) {
  var full = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  function getIcon(name2, iteration) {
    if (data.icons[name2] !== void 0) {
      return Object.assign({}, data.icons[name2]);
    }

    if (iteration > 5) {
      return null;
    }

    var aliases = data.aliases;

    if (aliases && aliases[name2] !== void 0) {
      var item = aliases[name2];
      var result2 = getIcon(item.parent, iteration + 1);

      if (result2) {
        return mergeIconData(result2, item);
      }

      return result2;
    }

    var chars = data.chars;

    if (!iteration && chars && chars[name2] !== void 0) {
      return getIcon(chars[name2], iteration + 1);
    }

    return null;
  }

  var result = getIcon(name, 0);

  if (result) {
    for (var key in iconDefaults) {
      if (result[key] === void 0 && data[key] !== void 0) {
        result[key] = data[key];
      }
    }
  }

  return result && full ? fullIcon(result) : result;
}

function isVariation(item) {
  for (var key in iconDefaults) {
    if (item[key] !== void 0) {
      return true;
    }
  }

  return false;
}

function parseIconSet(data, callback, options) {
  options = options || {};
  var names = [];

  if (typeof data !== "object" || typeof data.icons !== "object") {
    return names;
  }

  if (data.not_found instanceof Array) {
    data.not_found.forEach(function (name) {
      callback(name, null);
      names.push(name);
    });
  }

  var icons = data.icons;
  Object.keys(icons).forEach(function (name) {
    var iconData = getIconData$1(data, name, true);

    if (iconData) {
      callback(name, iconData);
      names.push(name);
    }
  });
  var parseAliases = options.aliases || "all";

  if (parseAliases !== "none" && typeof data.aliases === "object") {
    var aliases = data.aliases;
    Object.keys(aliases).forEach(function (name) {
      if (parseAliases === "variations" && isVariation(aliases[name])) {
        return;
      }

      var iconData = getIconData$1(data, name, true);

      if (iconData) {
        callback(name, iconData);
        names.push(name);
      }
    });
  }

  return names;
}

var optionalProperties = {
  provider: "string",
  aliases: "object",
  not_found: "object"
};

for (var prop in iconDefaults) {
  optionalProperties[prop] = typeof iconDefaults[prop];
}

function quicklyValidateIconSet(obj) {
  if (typeof obj !== "object" || obj === null) {
    return null;
  }

  var data = obj;

  if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") {
    return null;
  }

  for (var _prop in optionalProperties) {
    if (obj[_prop] !== void 0 && typeof obj[_prop] !== optionalProperties[_prop]) {
      return null;
    }
  }

  var icons = data.icons;

  for (var name in icons) {
    var icon = icons[name];

    if (!name.match(matchName) || typeof icon.body !== "string") {
      return null;
    }

    for (var _prop2 in iconDefaults) {
      if (icon[_prop2] !== void 0 && typeof icon[_prop2] !== typeof iconDefaults[_prop2]) {
        return null;
      }
    }
  }

  var aliases = data.aliases;

  if (aliases) {
    for (var _name in aliases) {
      var _icon = aliases[_name];
      var parent = _icon.parent;

      if (!_name.match(matchName) || typeof parent !== "string" || !icons[parent] && !aliases[parent]) {
        return null;
      }

      for (var _prop3 in iconDefaults) {
        if (_icon[_prop3] !== void 0 && typeof _icon[_prop3] !== typeof iconDefaults[_prop3]) {
          return null;
        }
      }
    }
  }

  return data;
}

var storageVersion = 1;
var storage$1 = /* @__PURE__ */Object.create(null);

try {
  var w = window || self;

  if (w && w._iconifyStorage.version === storageVersion) {
    storage$1 = w._iconifyStorage.storage;
  }
} catch (err) {}

function shareStorage() {
  try {
    var _w = window || self;

    if (_w && !_w._iconifyStorage) {
      _w._iconifyStorage = {
        version: storageVersion,
        storage: storage$1
      };
    }
  } catch (err) {}
}

function newStorage(provider, prefix) {
  return {
    provider: provider,
    prefix: prefix,
    icons: /* @__PURE__ */Object.create(null),
    missing: /* @__PURE__ */Object.create(null)
  };
}

function getStorage(provider, prefix) {
  if (storage$1[provider] === void 0) {
    storage$1[provider] = /* @__PURE__ */Object.create(null);
  }

  var providerStorage = storage$1[provider];

  if (providerStorage[prefix] === void 0) {
    providerStorage[prefix] = newStorage(provider, prefix);
  }

  return providerStorage[prefix];
}

function addIconSet(storage2, data) {
  if (!quicklyValidateIconSet(data)) {
    return [];
  }

  var t = Date.now();
  return parseIconSet(data, function (name, icon) {
    if (icon) {
      storage2.icons[name] = icon;
    } else {
      storage2.missing[name] = t;
    }
  });
}

function addIconToStorage(storage2, name, icon) {
  try {
    if (typeof icon.body === "string") {
      storage2.icons[name] = Object.freeze(fullIcon(icon));
      return true;
    }
  } catch (err) {}

  return false;
}

function getIconFromStorage(storage2, name) {
  var value = storage2.icons[name];
  return value === void 0 ? null : value;
}

function listIcons(provider, prefix) {
  var allIcons = [];
  var providers;

  if (typeof provider === "string") {
    providers = [provider];
  } else {
    providers = Object.keys(storage$1);
  }

  providers.forEach(function (provider2) {
    var prefixes;

    if (typeof provider2 === "string" && typeof prefix === "string") {
      prefixes = [prefix];
    } else {
      prefixes = storage$1[provider2] === void 0 ? [] : Object.keys(storage$1[provider2]);
    }

    prefixes.forEach(function (prefix2) {
      var storage2 = getStorage(provider2, prefix2);
      var icons = Object.keys(storage2.icons).map(function (name) {
        return (provider2 !== "" ? "@" + provider2 + ":" : "") + prefix2 + ":" + name;
      });
      allIcons = allIcons.concat(icons);
    });
  });
  return allIcons;
}

var simpleNames = false;

function allowSimpleNames(allow) {
  if (typeof allow === "boolean") {
    simpleNames = allow;
  }

  return simpleNames;
}

function getIconData(name) {
  var icon = typeof name === "string" ? stringToIcon(name, true, simpleNames) : name;
  return icon ? getIconFromStorage(getStorage(icon.provider, icon.prefix), icon.name) : null;
}

function addIcon(name, data) {
  var icon = stringToIcon(name, true, simpleNames);

  if (!icon) {
    return false;
  }

  var storage = getStorage(icon.provider, icon.prefix);
  return addIconToStorage(storage, icon.name, data);
}

function addCollection(data, provider) {
  if (typeof data !== "object") {
    return false;
  }

  if (typeof provider !== "string") {
    provider = typeof data.provider === "string" ? data.provider : "";
  }

  if (simpleNames && provider === "" && (typeof data.prefix !== "string" || data.prefix === "")) {
    var added = false;

    if (quicklyValidateIconSet(data)) {
      data.prefix = "";
      parseIconSet(data, function (name, icon) {
        if (icon && addIcon(name, icon)) {
          added = true;
        }
      });
    }

    return added;
  }

  if (typeof data.prefix !== "string" || !validateIcon({
    provider: provider,
    prefix: data.prefix,
    name: "a"
  })) {
    return false;
  }

  var storage = getStorage(provider, data.prefix);
  return !!addIconSet(storage, data);
}

function iconExists(name) {
  return getIconData(name) !== null;
}

function getIcon(name) {
  var result = getIconData(name);
  return result ? _objectSpread({}, result) : null;
}

var defaults = Object.freeze({
  inline: false,
  width: null,
  height: null,
  hAlign: "center",
  vAlign: "middle",
  slice: false,
  hFlip: false,
  vFlip: false,
  rotate: 0
});

function mergeCustomisations(defaults2, item) {
  var result = {};

  for (var key in defaults2) {
    var attr = key;
    result[attr] = defaults2[attr];

    if (item[attr] === void 0) {
      continue;
    }

    var value = item[attr];

    switch (attr) {
      case "inline":
      case "slice":
        if (typeof value === "boolean") {
          result[attr] = value;
        }

        break;

      case "hFlip":
      case "vFlip":
        if (value === true) {
          result[attr] = !result[attr];
        }

        break;

      case "hAlign":
      case "vAlign":
        if (typeof value === "string" && value !== "") {
          result[attr] = value;
        }

        break;

      case "width":
      case "height":
        if (typeof value === "string" && value !== "" || typeof value === "number" && value || value === null) {
          result[attr] = value;
        }

        break;

      case "rotate":
        if (typeof value === "number") {
          result[attr] += value;
        }

        break;
    }
  }

  return result;
}

var unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
var unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;

function calculateSize(size, ratio, precision) {
  if (ratio === 1) {
    return size;
  }

  precision = precision === void 0 ? 100 : precision;

  if (typeof size === "number") {
    return Math.ceil(size * ratio * precision) / precision;
  }

  if (typeof size !== "string") {
    return size;
  }

  var oldParts = size.split(unitsSplit);

  if (oldParts === null || !oldParts.length) {
    return size;
  }

  var newParts = [];
  var code = oldParts.shift();
  var isNumber = unitsTest.test(code);

  while (true) {
    if (isNumber) {
      var num = parseFloat(code);

      if (isNaN(num)) {
        newParts.push(code);
      } else {
        newParts.push(Math.ceil(num * ratio * precision) / precision);
      }
    } else {
      newParts.push(code);
    }

    code = oldParts.shift();

    if (code === void 0) {
      return newParts.join("");
    }

    isNumber = !isNumber;
  }
}

function preserveAspectRatio(props) {
  var result = "";

  switch (props.hAlign) {
    case "left":
      result += "xMin";
      break;

    case "right":
      result += "xMax";
      break;

    default:
      result += "xMid";
  }

  switch (props.vAlign) {
    case "top":
      result += "YMin";
      break;

    case "bottom":
      result += "YMax";
      break;

    default:
      result += "YMid";
  }

  result += props.slice ? " slice" : " meet";
  return result;
}

function iconToSVG(icon, customisations) {
  var box = {
    left: icon.left,
    top: icon.top,
    width: icon.width,
    height: icon.height
  };
  var body = icon.body;
  [icon, customisations].forEach(function (props) {
    var transformations = [];
    var hFlip = props.hFlip;
    var vFlip = props.vFlip;
    var rotation = props.rotate;

    if (hFlip) {
      if (vFlip) {
        rotation += 2;
      } else {
        transformations.push("translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")");
        transformations.push("scale(-1 1)");
        box.top = box.left = 0;
      }
    } else if (vFlip) {
      transformations.push("translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")");
      transformations.push("scale(1 -1)");
      box.top = box.left = 0;
    }

    var tempValue;

    if (rotation < 0) {
      rotation -= Math.floor(rotation / 4) * 4;
    }

    rotation = rotation % 4;

    switch (rotation) {
      case 1:
        tempValue = box.height / 2 + box.top;
        transformations.unshift("rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")");
        break;

      case 2:
        transformations.unshift("rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")");
        break;

      case 3:
        tempValue = box.width / 2 + box.left;
        transformations.unshift("rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")");
        break;
    }

    if (rotation % 2 === 1) {
      if (box.left !== 0 || box.top !== 0) {
        tempValue = box.left;
        box.left = box.top;
        box.top = tempValue;
      }

      if (box.width !== box.height) {
        tempValue = box.width;
        box.width = box.height;
        box.height = tempValue;
      }
    }

    if (transformations.length) {
      body = '<g transform="' + transformations.join(" ") + '">' + body + "</g>";
    }
  });
  var width, height;

  if (customisations.width === null && customisations.height === null) {
    height = "1em";
    width = calculateSize(height, box.width / box.height);
  } else if (customisations.width !== null && customisations.height !== null) {
    width = customisations.width;
    height = customisations.height;
  } else if (customisations.height !== null) {
    height = customisations.height;
    width = calculateSize(height, box.width / box.height);
  } else {
    width = customisations.width;
    height = calculateSize(width, box.height / box.width);
  }

  if (width === "auto") {
    width = box.width;
  }

  if (height === "auto") {
    height = box.height;
  }

  width = typeof width === "string" ? width : width.toString() + "";
  height = typeof height === "string" ? height : height.toString() + "";
  var result = {
    attributes: {
      width: width,
      height: height,
      preserveAspectRatio: preserveAspectRatio(customisations),
      viewBox: box.left.toString() + " " + box.top.toString() + " " + box.width.toString() + " " + box.height.toString()
    },
    body: body
  };

  if (customisations.inline) {
    result.inline = true;
  }

  return result;
}

function buildIcon(icon, customisations) {
  return iconToSVG(fullIcon(icon), customisations ? mergeCustomisations(defaults, customisations) : defaults);
}

var regex = /\sid="(\S+)"/g;
var randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
var counter = 0;

function replaceIDs(body) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : randomPrefix;
  var ids = [];
  var match;

  while (match = regex.exec(body)) {
    ids.push(match[1]);
  }

  if (!ids.length) {
    return body;
  }

  ids.forEach(function (id) {
    var newID = typeof prefix === "function" ? prefix(id) : prefix + (counter++).toString();
    var escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    body = body.replace(new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"), "$1" + newID + "$3");
  });
  return body;
}

var storage = /* @__PURE__ */Object.create(null);

function setAPIModule(provider, item) {
  storage[provider] = item;
}

function getAPIModule(provider) {
  return storage[provider] || storage[""];
}

function createAPIConfig(source) {
  var resources;

  if (typeof source.resources === "string") {
    resources = [source.resources];
  } else {
    resources = source.resources;

    if (!(resources instanceof Array) || !resources.length) {
      return null;
    }
  }

  var result = {
    resources: resources,
    path: source.path === void 0 ? "/" : source.path,
    maxURL: source.maxURL ? source.maxURL : 500,
    rotate: source.rotate ? source.rotate : 750,
    timeout: source.timeout ? source.timeout : 5e3,
    random: source.random === true,
    index: source.index ? source.index : 0,
    dataAfterTimeout: source.dataAfterTimeout !== false
  };
  return result;
}

var configStorage = /* @__PURE__ */Object.create(null);
var fallBackAPISources = ["https://api.simplesvg.com", "https://api.unisvg.com"];
var fallBackAPI = [];

while (fallBackAPISources.length > 0) {
  if (fallBackAPISources.length === 1) {
    fallBackAPI.push(fallBackAPISources.shift());
  } else {
    if (Math.random() > 0.5) {
      fallBackAPI.push(fallBackAPISources.shift());
    } else {
      fallBackAPI.push(fallBackAPISources.pop());
    }
  }
}

configStorage[""] = createAPIConfig({
  resources: ["https://api.iconify.design"].concat(fallBackAPI)
});

function addAPIProvider(provider, customConfig) {
  var config = createAPIConfig(customConfig);

  if (config === null) {
    return false;
  }

  configStorage[provider] = config;
  return true;
}

function getAPIConfig(provider) {
  return configStorage[provider];
}

function listAPIProviders() {
  return Object.keys(configStorage);
}

var mergeParams = function mergeParams(base, params) {
  var result = base,
      hasParams = result.indexOf("?") !== -1;

  function paramToString(value) {
    switch (typeof value) {
      case "boolean":
        return value ? "true" : "false";

      case "number":
        return encodeURIComponent(value);

      case "string":
        return encodeURIComponent(value);

      default:
        throw new Error("Invalid parameter");
    }
  }

  Object.keys(params).forEach(function (key) {
    var value;

    try {
      value = paramToString(params[key]);
    } catch (err) {
      return;
    }

    result += (hasParams ? "&" : "?") + encodeURIComponent(key) + "=" + value;
    hasParams = true;
  });
  return result;
};

var maxLengthCache = {};
var pathCache = {};

var detectFetch = function detectFetch() {
  var callback;

  try {
    callback = fetch;

    if (typeof callback === "function") {
      return callback;
    }
  } catch (err) {}

  return null;
};

var fetchModule = detectFetch();

function setFetch(fetch2) {
  fetchModule = fetch2;
}

function getFetch() {
  return fetchModule;
}

function calculateMaxLength(provider, prefix) {
  var config = getAPIConfig(provider);

  if (!config) {
    return 0;
  }

  var result;

  if (!config.maxURL) {
    result = 0;
  } else {
    var maxHostLength = 0;
    config.resources.forEach(function (item) {
      var host = item;
      maxHostLength = Math.max(maxHostLength, host.length);
    });
    var url = mergeParams(prefix + ".json", {
      icons: ""
    });
    result = config.maxURL - maxHostLength - config.path.length - url.length;
  }

  var cacheKey = provider + ":" + prefix;
  pathCache[provider] = config.path;
  maxLengthCache[cacheKey] = result;
  return result;
}

function shouldAbort(status) {
  return status === 404;
}

var prepare = function prepare(provider, prefix, icons) {
  var results = [];
  var maxLength = maxLengthCache[prefix];

  if (maxLength === void 0) {
    maxLength = calculateMaxLength(provider, prefix);
  }

  var type = "icons";
  var item = {
    type: type,
    provider: provider,
    prefix: prefix,
    icons: []
  };
  var length = 0;
  icons.forEach(function (name, index) {
    length += name.length + 1;

    if (length >= maxLength && index > 0) {
      results.push(item);
      item = {
        type: type,
        provider: provider,
        prefix: prefix,
        icons: []
      };
      length = name.length;
    }

    item.icons.push(name);
  });
  results.push(item);
  return results;
};

function getPath(provider) {
  if (typeof provider === "string") {
    if (pathCache[provider] === void 0) {
      var _config = getAPIConfig(provider);

      if (!_config) {
        return "/";
      }

      pathCache[provider] = _config.path;
    }

    return pathCache[provider];
  }

  return "/";
}

var send = function send(host, params, callback) {
  if (!fetchModule) {
    callback("abort", 424);
    return;
  }

  var path = getPath(params.provider);

  switch (params.type) {
    case "icons":
      {
        var prefix = params.prefix;
        var icons = params.icons;
        var iconsList = icons.join(",");
        path += mergeParams(prefix + ".json", {
          icons: iconsList
        });
        break;
      }

    case "custom":
      {
        var uri = params.uri;
        path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
        break;
      }

    default:
      callback("abort", 400);
      return;
  }

  var defaultError = 503;
  fetchModule(host + path).then(function (response) {
    var status = response.status;

    if (status !== 200) {
      setTimeout(function () {
        callback(shouldAbort(status) ? "abort" : "next", status);
      });
      return;
    }

    defaultError = 501;
    return response.json();
  }).then(function (data) {
    if (typeof data !== "object" || data === null) {
      setTimeout(function () {
        callback("next", defaultError);
      });
      return;
    }

    setTimeout(function () {
      callback("success", data);
    });
  }).catch(function () {
    callback("next", defaultError);
  });
};

var fetchAPIModule = {
  prepare: prepare,
  send: send
};

function sortIcons(icons) {
  var result = {
    loaded: [],
    missing: [],
    pending: []
  };
  var storage = /* @__PURE__ */Object.create(null);
  icons.sort(function (a, b) {
    if (a.provider !== b.provider) {
      return a.provider.localeCompare(b.provider);
    }

    if (a.prefix !== b.prefix) {
      return a.prefix.localeCompare(b.prefix);
    }

    return a.name.localeCompare(b.name);
  });
  var lastIcon = {
    provider: "",
    prefix: "",
    name: ""
  };
  icons.forEach(function (icon) {
    if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) {
      return;
    }

    lastIcon = icon;
    var provider = icon.provider;
    var prefix = icon.prefix;
    var name = icon.name;

    if (storage[provider] === void 0) {
      storage[provider] = /* @__PURE__ */Object.create(null);
    }

    var providerStorage = storage[provider];

    if (providerStorage[prefix] === void 0) {
      providerStorage[prefix] = getStorage(provider, prefix);
    }

    var localStorage = providerStorage[prefix];
    var list;

    if (localStorage.icons[name] !== void 0) {
      list = result.loaded;
    } else if (prefix === "" || localStorage.missing[name] !== void 0) {
      list = result.missing;
    } else {
      list = result.pending;
    }

    var item = {
      provider: provider,
      prefix: prefix,
      name: name
    };
    list.push(item);
  });
  return result;
}

var callbacks = /* @__PURE__ */Object.create(null);
var pendingUpdates = /* @__PURE__ */Object.create(null);

function removeCallback(sources, id) {
  sources.forEach(function (source) {
    var provider = source.provider;

    if (callbacks[provider] === void 0) {
      return;
    }

    var providerCallbacks = callbacks[provider];
    var prefix = source.prefix;
    var items = providerCallbacks[prefix];

    if (items) {
      providerCallbacks[prefix] = items.filter(function (row) {
        return row.id !== id;
      });
    }
  });
}

function updateCallbacks(provider, prefix) {
  if (pendingUpdates[provider] === void 0) {
    pendingUpdates[provider] = /* @__PURE__ */Object.create(null);
  }

  var providerPendingUpdates = pendingUpdates[provider];

  if (!providerPendingUpdates[prefix]) {
    providerPendingUpdates[prefix] = true;
    setTimeout(function () {
      providerPendingUpdates[prefix] = false;

      if (callbacks[provider] === void 0 || callbacks[provider][prefix] === void 0) {
        return;
      }

      var items = callbacks[provider][prefix].slice(0);

      if (!items.length) {
        return;
      }

      var storage = getStorage(provider, prefix);
      var hasPending = false;
      items.forEach(function (item) {
        var icons = item.icons;
        var oldLength = icons.pending.length;
        icons.pending = icons.pending.filter(function (icon) {
          if (icon.prefix !== prefix) {
            return true;
          }

          var name = icon.name;

          if (storage.icons[name] !== void 0) {
            icons.loaded.push({
              provider: provider,
              prefix: prefix,
              name: name
            });
          } else if (storage.missing[name] !== void 0) {
            icons.missing.push({
              provider: provider,
              prefix: prefix,
              name: name
            });
          } else {
            hasPending = true;
            return true;
          }

          return false;
        });

        if (icons.pending.length !== oldLength) {
          if (!hasPending) {
            removeCallback([{
              provider: provider,
              prefix: prefix
            }], item.id);
          }

          item.callback(icons.loaded.slice(0), icons.missing.slice(0), icons.pending.slice(0), item.abort);
        }
      });
    });
  }
}

var idCounter = 0;

function storeCallback(callback, icons, pendingSources) {
  var id = idCounter++;
  var abort = removeCallback.bind(null, pendingSources, id);

  if (!icons.pending.length) {
    return abort;
  }

  var item = {
    id: id,
    icons: icons,
    callback: callback,
    abort: abort
  };
  pendingSources.forEach(function (source) {
    var provider = source.provider;
    var prefix = source.prefix;

    if (callbacks[provider] === void 0) {
      callbacks[provider] = /* @__PURE__ */Object.create(null);
    }

    var providerCallbacks = callbacks[provider];

    if (providerCallbacks[prefix] === void 0) {
      providerCallbacks[prefix] = [];
    }

    providerCallbacks[prefix].push(item);
  });
  return abort;
}

function listToIcons(list) {
  var validate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var simpleNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var result = [];
  list.forEach(function (item) {
    var icon = typeof item === "string" ? stringToIcon(item, false, simpleNames) : item;

    if (!validate || validateIcon(icon, simpleNames)) {
      result.push({
        provider: icon.provider,
        prefix: icon.prefix,
        name: icon.name
      });
    }
  });
  return result;
} // src/config.ts


var defaultConfig = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: false,
  dataAfterTimeout: false
}; // src/query.ts

function sendQuery(config, payload, query, done) {
  var resourcesCount = config.resources.length;
  var startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
  var resources;

  if (config.random) {
    var list = config.resources.slice(0);
    resources = [];

    while (list.length > 1) {
      var nextIndex = Math.floor(Math.random() * list.length);
      resources.push(list[nextIndex]);
      list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
    }

    resources = resources.concat(list);
  } else {
    resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
  }

  var startTime = Date.now();
  var status = "pending";
  var queriesSent = 0;
  var lastError;
  var timer = null;
  var queue = [];
  var doneCallbacks = [];

  if (typeof done === "function") {
    doneCallbacks.push(done);
  }

  function resetTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function abort() {
    if (status === "pending") {
      status = "aborted";
    }

    resetTimer();
    queue.forEach(function (item) {
      if (item.status === "pending") {
        item.status = "aborted";
      }
    });
    queue = [];
  }

  function subscribe(callback, overwrite) {
    if (overwrite) {
      doneCallbacks = [];
    }

    if (typeof callback === "function") {
      doneCallbacks.push(callback);
    }
  }

  function getQueryStatus() {
    return {
      startTime: startTime,
      payload: payload,
      status: status,
      queriesSent: queriesSent,
      queriesPending: queue.length,
      subscribe: subscribe,
      abort: abort
    };
  }

  function failQuery() {
    status = "failed";
    doneCallbacks.forEach(function (callback) {
      callback(void 0, lastError);
    });
  }

  function clearQueue() {
    queue.forEach(function (item) {
      if (item.status === "pending") {
        item.status = "aborted";
      }
    });
    queue = [];
  }

  function moduleResponse(item, response, data) {
    var isError = response !== "success";
    queue = queue.filter(function (queued) {
      return queued !== item;
    });

    switch (status) {
      case "pending":
        break;

      case "failed":
        if (isError || !config.dataAfterTimeout) {
          return;
        }

        break;

      default:
        return;
    }

    if (response === "abort") {
      lastError = data;
      failQuery();
      return;
    }

    if (isError) {
      lastError = data;

      if (!queue.length) {
        if (!resources.length) {
          failQuery();
        } else {
          execNext();
        }
      }

      return;
    }

    resetTimer();
    clearQueue();

    if (!config.random) {
      var index = config.resources.indexOf(item.resource);

      if (index !== -1 && index !== config.index) {
        config.index = index;
      }
    }

    status = "completed";
    doneCallbacks.forEach(function (callback) {
      callback(data);
    });
  }

  function execNext() {
    if (status !== "pending") {
      return;
    }

    resetTimer();
    var resource = resources.shift();

    if (resource === void 0) {
      if (queue.length) {
        timer = setTimeout(function () {
          resetTimer();

          if (status === "pending") {
            clearQueue();
            failQuery();
          }
        }, config.timeout);
        return;
      }

      failQuery();
      return;
    }

    var item = {
      status: "pending",
      resource: resource,
      callback: function callback(status2, data) {
        moduleResponse(item, status2, data);
      }
    };
    queue.push(item);
    queriesSent++;
    timer = setTimeout(execNext, config.rotate);
    query(resource, payload, item.callback);
  }

  setTimeout(execNext);
  return getQueryStatus;
} // src/index.ts


function setConfig(config) {
  if (typeof config !== "object" || typeof config.resources !== "object" || !(config.resources instanceof Array) || !config.resources.length) {
    throw new Error("Invalid Reduncancy configuration");
  }

  var newConfig = /* @__PURE__ */Object.create(null);
  var key;

  for (key in defaultConfig) {
    if (config[key] !== void 0) {
      newConfig[key] = config[key];
    } else {
      newConfig[key] = defaultConfig[key];
    }
  }

  return newConfig;
}

function initRedundancy(cfg) {
  var config = setConfig(cfg);
  var queries = [];

  function cleanup() {
    queries = queries.filter(function (item) {
      return item().status === "pending";
    });
  }

  function query(payload, queryCallback, doneCallback) {
    var query2 = sendQuery(config, payload, queryCallback, function (data, error) {
      cleanup();

      if (doneCallback) {
        doneCallback(data, error);
      }
    });
    queries.push(query2);
    return query2;
  }

  function find(callback) {
    var result = queries.find(function (value) {
      return callback(value);
    });
    return result !== void 0 ? result : null;
  }

  var instance = {
    query: query,
    find: find,
    setIndex: function setIndex(index) {
      config.index = index;
    },
    getIndex: function getIndex() {
      return config.index;
    },
    cleanup: cleanup
  };
  return instance;
}

function emptyCallback$1() {}

var redundancyCache = /* @__PURE__ */Object.create(null);

function getRedundancyCache(provider) {
  if (redundancyCache[provider] === void 0) {
    var _config2 = getAPIConfig(provider);

    if (!_config2) {
      return;
    }

    var redundancy = initRedundancy(_config2);
    var cachedReundancy = {
      config: _config2,
      redundancy: redundancy
    };
    redundancyCache[provider] = cachedReundancy;
  }

  return redundancyCache[provider];
}

function sendAPIQuery(target, query, callback) {
  var redundancy;
  var send;

  if (typeof target === "string") {
    var api = getAPIModule(target);

    if (!api) {
      callback(void 0, 424);
      return emptyCallback$1;
    }

    send = api.send;
    var cached = getRedundancyCache(target);

    if (cached) {
      redundancy = cached.redundancy;
    }
  } else {
    var _config3 = createAPIConfig(target);

    if (_config3) {
      redundancy = initRedundancy(_config3);
      var moduleKey = target.resources ? target.resources[0] : "";

      var _api2 = getAPIModule(moduleKey);

      if (_api2) {
        send = _api2.send;
      }
    }
  }

  if (!redundancy || !send) {
    callback(void 0, 424);
    return emptyCallback$1;
  }

  return redundancy.query(query, send, callback)().abort;
}

var cache = {};

function emptyCallback() {}

var pendingIcons = /* @__PURE__ */Object.create(null);
var iconsToLoad = /* @__PURE__ */Object.create(null);
var loaderFlags = /* @__PURE__ */Object.create(null);
var queueFlags = /* @__PURE__ */Object.create(null);

function loadedNewIcons(provider, prefix) {
  if (loaderFlags[provider] === void 0) {
    loaderFlags[provider] = /* @__PURE__ */Object.create(null);
  }

  var providerLoaderFlags = loaderFlags[provider];

  if (!providerLoaderFlags[prefix]) {
    providerLoaderFlags[prefix] = true;
    setTimeout(function () {
      providerLoaderFlags[prefix] = false;
      updateCallbacks(provider, prefix);
    });
  }
}

var errorsCache = /* @__PURE__ */Object.create(null);

function loadNewIcons(provider, prefix, icons) {
  function err() {
    var key = (provider === "" ? "" : "@" + provider + ":") + prefix;
    var time = Math.floor(Date.now() / 6e4);

    if (errorsCache[key] < time) {
      errorsCache[key] = time;
      console.error('Unable to retrieve icons for "' + key + '" because API is not configured properly.');
    }
  }

  if (iconsToLoad[provider] === void 0) {
    iconsToLoad[provider] = /* @__PURE__ */Object.create(null);
  }

  var providerIconsToLoad = iconsToLoad[provider];

  if (queueFlags[provider] === void 0) {
    queueFlags[provider] = /* @__PURE__ */Object.create(null);
  }

  var providerQueueFlags = queueFlags[provider];

  if (pendingIcons[provider] === void 0) {
    pendingIcons[provider] = /* @__PURE__ */Object.create(null);
  }

  var providerPendingIcons = pendingIcons[provider];

  if (providerIconsToLoad[prefix] === void 0) {
    providerIconsToLoad[prefix] = icons;
  } else {
    providerIconsToLoad[prefix] = providerIconsToLoad[prefix].concat(icons).sort();
  }

  if (!providerQueueFlags[prefix]) {
    providerQueueFlags[prefix] = true;
    setTimeout(function () {
      providerQueueFlags[prefix] = false;
      var icons2 = providerIconsToLoad[prefix];
      delete providerIconsToLoad[prefix];
      var api = getAPIModule(provider);

      if (!api) {
        err();
        return;
      }

      var params = api.prepare(provider, prefix, icons2);
      params.forEach(function (item) {
        sendAPIQuery(provider, item, function (data, error) {
          var storage = getStorage(provider, prefix);

          if (typeof data !== "object") {
            if (error !== 404) {
              return;
            }

            var t = Date.now();
            item.icons.forEach(function (name) {
              storage.missing[name] = t;
            });
          } else {
            try {
              var parsed = addIconSet(storage, data);

              if (!parsed.length) {
                return;
              }

              var pending = providerPendingIcons[prefix];
              parsed.forEach(function (name) {
                delete pending[name];
              });

              if (cache.store) {
                cache.store(provider, data);
              }
            } catch (err2) {
              console.error(err2);
            }
          }

          loadedNewIcons(provider, prefix);
        });
      });
    });
  }
}

var loadIcons = function loadIcons(icons, callback) {
  var cleanedIcons = listToIcons(icons, true, allowSimpleNames());
  var sortedIcons = sortIcons(cleanedIcons);

  if (!sortedIcons.pending.length) {
    var callCallback = true;

    if (callback) {
      setTimeout(function () {
        if (callCallback) {
          callback(sortedIcons.loaded, sortedIcons.missing, sortedIcons.pending, emptyCallback);
        }
      });
    }

    return function () {
      callCallback = false;
    };
  }

  var newIcons = /* @__PURE__ */Object.create(null);
  var sources = [];
  var lastProvider, lastPrefix;
  sortedIcons.pending.forEach(function (icon) {
    var provider = icon.provider;
    var prefix = icon.prefix;

    if (prefix === lastPrefix && provider === lastProvider) {
      return;
    }

    lastProvider = provider;
    lastPrefix = prefix;
    sources.push({
      provider: provider,
      prefix: prefix
    });

    if (pendingIcons[provider] === void 0) {
      pendingIcons[provider] = /* @__PURE__ */Object.create(null);
    }

    var providerPendingIcons = pendingIcons[provider];

    if (providerPendingIcons[prefix] === void 0) {
      providerPendingIcons[prefix] = /* @__PURE__ */Object.create(null);
    }

    if (newIcons[provider] === void 0) {
      newIcons[provider] = /* @__PURE__ */Object.create(null);
    }

    var providerNewIcons = newIcons[provider];

    if (providerNewIcons[prefix] === void 0) {
      providerNewIcons[prefix] = [];
    }
  });
  var time = Date.now();
  sortedIcons.pending.forEach(function (icon) {
    var provider = icon.provider;
    var prefix = icon.prefix;
    var name = icon.name;
    var pendingQueue = pendingIcons[provider][prefix];

    if (pendingQueue[name] === void 0) {
      pendingQueue[name] = time;
      newIcons[provider][prefix].push(name);
    }
  });
  sources.forEach(function (source) {
    var provider = source.provider;
    var prefix = source.prefix;

    if (newIcons[provider][prefix].length) {
      loadNewIcons(provider, prefix, newIcons[provider][prefix]);
    }
  });
  return callback ? storeCallback(callback, sortedIcons, sources) : emptyCallback;
};

var loadIcon = function loadIcon(icon) {
  return new Promise(function (fulfill, reject) {
    var iconObj = typeof icon === "string" ? stringToIcon(icon) : icon;
    loadIcons([iconObj || icon], function (loaded) {
      if (loaded.length && iconObj) {
        var _storage = getStorage(iconObj.provider, iconObj.prefix);

        var data = getIconFromStorage(_storage, iconObj.name);

        if (data) {
          fulfill(data);
          return;
        }
      }

      reject(icon);
    });
  });
};

var cacheVersion = "iconify2";
var cachePrefix = "iconify";
var countKey = cachePrefix + "-count";
var versionKey = cachePrefix + "-version";
var hour = 36e5;
var cacheExpiration = 168;
var config = {
  local: true,
  session: true
};
var loaded = false;
var count = {
  local: 0,
  session: 0
};
var emptyList = {
  local: [],
  session: []
};

var _window = typeof window === "undefined" ? {} : window;

function getGlobal(key) {
  var attr = key + "Storage";

  try {
    if (_window && _window[attr] && typeof _window[attr].length === "number") {
      return _window[attr];
    }
  } catch (err) {}

  config[key] = false;
  return null;
}

function setCount(storage, key, value) {
  try {
    storage.setItem(countKey, value.toString());
    count[key] = value;
    return true;
  } catch (err) {
    return false;
  }
}

function getCount(storage) {
  var count2 = storage.getItem(countKey);

  if (count2) {
    var total = parseInt(count2);
    return total ? total : 0;
  }

  return 0;
}

function initCache(storage, key) {
  try {
    storage.setItem(versionKey, cacheVersion);
  } catch (err) {}

  setCount(storage, key, 0);
}

function destroyCache(storage) {
  try {
    var total = getCount(storage);

    for (var i = 0; i < total; i++) {
      storage.removeItem(cachePrefix + i.toString());
    }
  } catch (err) {}
}

var loadCache = function loadCache() {
  if (loaded) {
    return;
  }

  loaded = true;
  var minTime = Math.floor(Date.now() / hour) - cacheExpiration;

  function load(key) {
    var func = getGlobal(key);

    if (!func) {
      return;
    }

    var getItem = function getItem(index) {
      var name = cachePrefix + index.toString();
      var item = func.getItem(name);

      if (typeof item !== "string") {
        return false;
      }

      var valid = true;

      try {
        var data = JSON.parse(item);

        if (typeof data !== "object" || typeof data.cached !== "number" || data.cached < minTime || typeof data.provider !== "string" || typeof data.data !== "object" || typeof data.data.prefix !== "string") {
          valid = false;
        } else {
          var provider = data.provider;
          var prefix = data.data.prefix;

          var _storage2 = getStorage(provider, prefix);

          valid = addIconSet(_storage2, data.data).length > 0;
        }
      } catch (err) {
        valid = false;
      }

      if (!valid) {
        func.removeItem(name);
      }

      return valid;
    };

    try {
      var version = func.getItem(versionKey);

      if (version !== cacheVersion) {
        if (version) {
          destroyCache(func);
        }

        initCache(func, key);
        return;
      }

      var total = getCount(func);

      for (var i = total - 1; i >= 0; i--) {
        if (!getItem(i)) {
          if (i === total - 1) {
            total--;
          } else {
            emptyList[key].push(i);
          }
        }
      }

      setCount(func, key, total);
    } catch (err) {}
  }

  for (var key in config) {
    load(key);
  }
};

var storeCache = function storeCache(provider, data) {
  if (!loaded) {
    loadCache();
  }

  function store(key) {
    if (!config[key]) {
      return false;
    }

    var func = getGlobal(key);

    if (!func) {
      return false;
    }

    var index = emptyList[key].shift();

    if (index === void 0) {
      index = count[key];

      if (!setCount(func, key, index + 1)) {
        return false;
      }
    }

    try {
      var item = {
        cached: Math.floor(Date.now() / hour),
        provider: provider,
        data: data
      };
      func.setItem(cachePrefix + index.toString(), JSON.stringify(item));
    } catch (err) {
      return false;
    }

    return true;
  }

  if (!Object.keys(data.icons).length) {
    return;
  }

  if (data.not_found) {
    data = Object.assign({}, data);
    delete data.not_found;
  }

  if (!store("local")) {
    store("session");
  }
};

function toggleBrowserCache(storage, value) {
  switch (storage) {
    case "local":
    case "session":
      config[storage] = value;
      break;

    case "all":
      for (var key in config) {
        config[key] = value;
      }

      break;
  }
}

var separator = /[\s,]+/;

function flipFromString(custom, flip) {
  flip.split(separator).forEach(function (str) {
    var value = str.trim();

    switch (value) {
      case "horizontal":
        custom.hFlip = true;
        break;

      case "vertical":
        custom.vFlip = true;
        break;
    }
  });
}

function alignmentFromString(custom, align) {
  align.split(separator).forEach(function (str) {
    var value = str.trim();

    switch (value) {
      case "left":
      case "center":
      case "right":
        custom.hAlign = value;
        break;

      case "top":
      case "middle":
      case "bottom":
        custom.vAlign = value;
        break;

      case "slice":
      case "crop":
        custom.slice = true;
        break;

      case "meet":
        custom.slice = false;
    }
  });
}

function rotateFromString(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var units = value.replace(/^-?[0-9.]*/, "");

  function cleanup(value2) {
    while (value2 < 0) {
      value2 += 4;
    }

    return value2 % 4;
  }

  if (units === "") {
    var num = parseInt(value);
    return isNaN(num) ? 0 : cleanup(num);
  } else if (units !== value) {
    var split = 0;

    switch (units) {
      case "%":
        split = 25;
        break;

      case "deg":
        split = 90;
    }

    if (split) {
      var _num = parseFloat(value.slice(0, value.length - units.length));

      if (isNaN(_num)) {
        return 0;
      }

      _num = _num / split;
      return _num % 1 === 0 ? cleanup(_num) : 0;
    }
  }

  return defaultValue;
}
/**
 * Default SVG attributes
 */


var svgDefaults = {
  'xmlns': 'http://www.w3.org/2000/svg',
  'xmlnsXlink': 'http://www.w3.org/1999/xlink',
  'aria-hidden': true,
  'role': 'img',
  'style': {} // Include style if it isn't set to add verticalAlign later

};
/**
 * Default values for customisations for inline icon
 */

var inlineDefaults = _objectSpread({}, defaults, {
  inline: true
});
/**
 * Render icon
 */


var _render = function render( // Icon must be validated before calling this function
icon, // Partial properties
props, // True if icon should have vertical-align added
inline, // Optional reference for SVG, extracted by React.forwardRef()
ref) {
  // Get default properties
  var defaultProps = inline ? inlineDefaults : defaults; // Get all customisations

  var customisations = mergeCustomisations(defaultProps, props); // Create style

  var style = typeof props.style === 'object' && props.style !== null ? props.style : {}; // Create SVG component properties

  var componentProps = _objectSpread({}, svgDefaults, {
    ref: ref,
    style: style
  }); // Get element properties


  for (var key in props) {
    var value = props[key];

    if (value === void 0) {
      continue;
    }

    switch (key) {
      // Properties to ignore
      case 'icon':
      case 'style':
      case 'children':
      case 'onLoad':
      case '_ref':
      case '_inline':
        break;
      // Boolean attributes

      case 'inline':
      case 'hFlip':
      case 'vFlip':
        customisations[key] = value === true || value === 'true' || value === 1;
        break;
      // Flip as string: 'horizontal,vertical'

      case 'flip':
        if (typeof value === 'string') {
          flipFromString(customisations, value);
        }

        break;
      // Alignment as string

      case 'align':
        if (typeof value === 'string') {
          alignmentFromString(customisations, value);
        }

        break;
      // Color: copy to style

      case 'color':
        style.color = value;
        break;
      // Rotation as string

      case 'rotate':
        if (typeof value === 'string') {
          customisations[key] = rotateFromString(value);
        } else if (typeof value === 'number') {
          customisations[key] = value;
        }

        break;
      // Remove aria-hidden

      case 'ariaHidden':
      case 'aria-hidden':
        if (value !== true && value !== 'true') {
          delete componentProps['aria-hidden'];
        }

        break;
      // Copy missing property if it does not exist in customisations

      default:
        if (defaultProps[key] === void 0) {
          componentProps[key] = value;
        }

    }
  } // Generate icon


  var item = iconToSVG(icon, customisations); // Counter for ids based on "id" property to render icons consistently on server and client

  var localCounter = 0;
  var id = props.id;

  if (typeof id === 'string') {
    // Convert '-' to '_' to avoid errors in animations
    id = id.replace(/-/g, '_');
  } // Add icon stuff


  componentProps.dangerouslySetInnerHTML = {
    __html: replaceIDs(item.body, id ? function () {
      return id + 'ID' + localCounter++;
    } : 'iconifyReact')
  };

  for (var _key in item.attributes) {
    componentProps[_key] = item.attributes[_key];
  }

  if (item.inline && style.verticalAlign === void 0) {
    style.verticalAlign = '-0.125em';
  }

  return React.createElement('svg', componentProps);
};
/**
 * Enable cache
 */


function enableCache(storage) {
  toggleBrowserCache(storage, true);
}
/**
 * Disable cache
 */


function disableCache(storage) {
  toggleBrowserCache(storage, false);
}
/**
 * Initialise stuff
 */
// Enable short names


allowSimpleNames(true); // Set API module

setAPIModule('', fetchAPIModule);
/**
 * Browser stuff
 */

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  // Set cache and load existing cache
  cache.store = storeCache;
  loadCache();
  var _window2 = window; // Load icons from global "IconifyPreload"

  if (_window2.IconifyPreload !== void 0) {
    var preload = _window2.IconifyPreload;
    var err = 'Invalid IconifyPreload syntax.';

    if (typeof preload === 'object' && preload !== null) {
      (preload instanceof Array ? preload : [preload]).forEach(function (item) {
        try {
          if ( // Check if item is an object and not null/array
          typeof item !== 'object' || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
          typeof item.icons !== 'object' || typeof item.prefix !== 'string' || // Add icon set
          !addCollection(item)) {
            console.error(err);
          }
        } catch (e) {
          console.error(err);
        }
      });
    }
  } // Set API from global "IconifyProviders"


  if (_window2.IconifyProviders !== void 0) {
    var providers = _window2.IconifyProviders;

    if (typeof providers === 'object' && providers !== null) {
      for (var key in providers) {
        var _err = 'IconifyProviders[' + key + '] is invalid.';

        try {
          var value = providers[key];

          if (typeof value !== 'object' || !value || value.resources === void 0) {
            continue;
          }

          if (!addAPIProvider(key, value)) {
            console.error(_err);
          }
        } catch (e) {
          console.error(_err);
        }
      }
    }
  }
}

var IconComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(IconComponent, _React$Component);

  function IconComponent(props) {
    var _this;

    _classCallCheck(this, IconComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconComponent).call(this, props));
    _this.state = {
      // Render placeholder before component is mounted
      icon: null
    };
    return _this;
  }
  /**
   * Abort loading icon
   */


  _createClass(IconComponent, [{
    key: "_abortLoading",
    value: function _abortLoading() {
      if (this._loading) {
        this._loading.abort();

        this._loading = null;
      }
    }
    /**
     * Update state
     */

  }, {
    key: "_setData",
    value: function _setData(icon) {
      if (this.state.icon !== icon) {
        this.setState({
          icon: icon
        });
      }
    }
    /**
     * Check if icon should be loaded
     */

  }, {
    key: "_checkIcon",
    value: function _checkIcon(changed) {
      var state = this.state;
      var icon = this.props.icon; // Icon is an object

      if (typeof icon === 'object' && icon !== null && typeof icon.body === 'string') {
        // Stop loading
        this._icon = '';

        this._abortLoading();

        if (changed || state.icon === null) {
          // Set data if it was changed
          this._setData({
            data: fullIcon(icon)
          });
        }

        return;
      } // Invalid icon?


      var iconName;

      if (typeof icon !== 'string' || (iconName = stringToIcon(icon, false, true)) === null) {
        this._abortLoading();

        this._setData(null);

        return;
      } // Load icon


      var data = getIconData(iconName);

      if (data === null) {
        // Icon needs to be loaded
        if (!this._loading || this._loading.name !== icon) {
          // New icon to load
          this._abortLoading();

          this._icon = '';

          this._setData(null);

          this._loading = {
            name: icon,
            abort: loadIcons([iconName], this._checkIcon.bind(this, false))
          };
        }

        return;
      } // Icon data is available


      if (this._icon !== icon || state.icon === null) {
        // New icon or icon has been loaded
        this._abortLoading();

        this._icon = icon; // Add classes

        var classes = ['iconify'];

        if (iconName.prefix !== '') {
          classes.push('iconify--' + iconName.prefix);
        }

        if (iconName.provider !== '') {
          classes.push('iconify--' + iconName.provider);
        } // Set data


        this._setData({
          data: data,
          classes: classes
        });

        if (this.props.onLoad) {
          this.props.onLoad(icon);
        }
      }
    }
    /**
     * Component mounted
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._checkIcon(false);
    }
    /**
     * Component updated
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (oldProps.icon !== this.props.icon) {
        this._checkIcon(true);
      }
    }
    /**
     * Abort loading
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._abortLoading();
    }
    /**
     * Render
     */

  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var icon = this.state.icon;

      if (icon === null) {
        // Render placeholder
        return props.children ? props.children : React.createElement('span', {});
      } // Add classes


      var newProps = props;

      if (icon.classes) {
        newProps = _objectSpread({}, props, {
          className: (typeof props.className === 'string' ? props.className + ' ' : '') + icon.classes.join(' ')
        });
      } // Render icon


      return _render(icon.data, newProps, props._inline, props._ref);
    }
  }]);

  return IconComponent;
}(React.Component);
/**
 * Block icon
 *
 * @param props - Component properties
 */


var Icon = React.forwardRef(function Icon(props, ref) {
  var newProps = _objectSpread({}, props, {
    _ref: ref,
    _inline: false
  });

  return React.createElement(IconComponent, newProps);
});
/**
 * Inline icon (has negative verticalAlign that makes it behave like icon font)
 *
 * @param props - Component properties
 */

var InlineIcon = React.forwardRef(function InlineIcon(props, ref) {
  var newProps = _objectSpread({}, props, {
    _ref: ref,
    _inline: true
  });

  return React.createElement(IconComponent, newProps);
});
/**
 * Internal API
 */

var _api = {
  getAPIConfig: getAPIConfig,
  setAPIModule: setAPIModule,
  sendAPIQuery: sendAPIQuery,
  setFetch: setFetch,
  getFetch: getFetch,
  listAPIProviders: listAPIProviders,
  mergeParams: mergeParams
};
export { Icon, InlineIcon, _api, addAPIProvider, addCollection, addIcon, buildIcon, calculateSize, disableCache, enableCache, getIcon, iconExists, listIcons, loadIcon, loadIcons, replaceIDs, shareStorage };